import AdvancedSelector from './advanced-selector.vue'

AdvancedSelector.install = function (Vue) {
	Vue.component(AdvancedSelector.name, AdvancedSelector);
}

export default AdvancedSelector;